import { toPairs } from 'lodash';

export const getSelectedKeys = (obj: Record<string, boolean>): string[] =>
    toPairs(obj)
        .filter(([ , selected ]) => selected)
        .map(([ id ]) => id)
        .sort((a, b) => a.localeCompare(b))
;
